// extracted by mini-css-extract-plugin
export default {"showSecondPanel":"role_detail_side_panel-module___showSecondPanel___bd561325"};